// Funciones auxiliares para el formulario de paciente
export const formatearFecha = (valor) => {
  const limpio = valor.replace(/\D/g, "");
  let fechaFormateada = limpio;
  if (limpio.length >= 3 && limpio.length <= 4) {
    fechaFormateada = `${limpio.slice(0, 2)}/${limpio.slice(2, 4)}`;
  } else if (limpio.length >= 5 && limpio.length <= 8) {
    fechaFormateada = `${limpio.slice(0, 2)}/${limpio.slice(2, 4)}/${limpio.slice(4, 8)}`;
  }
  return fechaFormateada;
};

export const getTextoDesplegableSeleccionado = (array, codigo) => {
  const idx = array.findIndex((item) => item.codigo === codigo);
  return idx !== -1 ? array[idx].text : '';
};

export const validarFormRegistroPaciente = ({nombre, apellido, fechaNac, celular, nroDocumento, correo, tipoDoc}) => {
  let pasa = true;
  let errors = {};
  if (!nombre) { pasa = false; errors.nombre = true; }
  if (!apellido) { pasa = false; errors.apellido = true; }
  if (!fechaNac) { pasa = false; errors.fechaNac = true; }
  if (!celular) { pasa = false; errors.celular = true; }
  if (!nroDocumento) { pasa = false; errors.nroDocumento = true; }
  if (!correo || !(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g.test(correo))) {
    pasa = false; errors.correo = true;
  }
  if (tipoDoc === null || tipoDoc === undefined || tipoDoc === -1) { pasa = false; errors.tipoDoc = true; }
  return { pasa, errors };
};
